import { CloseButton } from 'components';

export const PopoverHeader = ({
  title,
  subtitle,
  onClose,
}: {
  title: string;
  subtitle: string;
  onClose: () => void;
}) => {
  return (
    <>
      <CloseButton onClick={onClose} data-ph-no-autocapture />
      <div className="mb-4 pr-6">
        <h3 className="text-lg text-center font-semibold text-foreground mb-1">{title}</h3>
        <p className="text-sm text-center text-muted-foreground whitespace-pre-line">{subtitle}</p>
      </div>
    </>
  );
};
